import {combineReducers} from "redux";
import storage from "redux-persist/lib/storage";
// slices
import userReducer from "./slices/user";
import groupsPublicReducer from "./slices/groupsPublic";
import {operatorsReducer} from "./slices/operators";
import settingsReducer from "./slices/settings";
import locationsReducer from "./slices/locations";
import synchronizationsReducer from "./slices/synchronization";
import {licenseReducer} from "./slices/license";
import {notificationsReducer} from './slices/notifications';
import taxCoreReducer from "./slices/taxCore";
import {discountReducer} from "./slices/discounts";
import busesReducer from "./slices/buses";
import {rateCardsReducer} from "./slices/rateCards";
import {ratesReducer} from "./slices/rate";
import customersReducer from "./slices/customers";
import carriersReducer from "./slices/carriers";
import {lineStationReducer} from "./slices/lineStations";
import {stationLocationsReducer} from "./slices/stationLocations";
import {linesReducer} from "./slices/lines";
import {departureReducer} from "./slices/departures";
import {RFIDReducer} from "./slices/rfid";
import {servicesReducer} from "./slices/services";
import {itemsReducer} from "./slices/items";
import {stationsReducer} from "./slices/stations";
import {ticketsReducer} from "./slices/tickets";
import countriesReducer from "./slices/countries";
import {regionsReducer} from "./slices/regions";
import {operationIntervalReducer} from "./slices/operationIntervals";
import {esirInvoicesReducer} from "./slices/esirInvoices";
import {logoReducer} from "./slices/userLogo";
import {newReportsReducer} from "./slices/newReport";
import {reportsReducer} from "./slices/reports";
import {invoicesReducer} from "./slices/invoices";
import {persistReducer} from "redux-persist";
import createInvoiceReducer from "./slices/createInvoice";
// ----------------------------------------------------------------------

const rootPersistConfig = {
    key: "root",
    storage,
    keyPrefix: "redux-",
    whitelist: []
};


const createInvoicePersistConfig = {
    key: "createInvoice",
    storage,
    keyPrefix: "redux-",
    whitelist: []
};

const rootReducer = combineReducers({
    synchronizations: synchronizationsReducer,
    notifications: notificationsReducer,
    taxCore: taxCoreReducer,
    settings: settingsReducer,
    operators: operatorsReducer,
    locations: locationsReducer,
    groupsPublic: groupsPublicReducer,
    user: userReducer,
    license: licenseReducer,
    discounts: discountReducer,
    bus: busesReducer,
    rateCards: rateCardsReducer,
    rates: ratesReducer,
    customers: customersReducer,
    lineStations: lineStationReducer,
    stationLocations: stationLocationsReducer,
    lines: linesReducer,
    departures: departureReducer,
    RFID: RFIDReducer,
    services: servicesReducer,
    items: itemsReducer,
    stations: stationsReducer,
    tickets: ticketsReducer,
    countriess: countriesReducer,
    regions: regionsReducer,
    operationIntervals: operationIntervalReducer,
    esirInvoices: esirInvoicesReducer,
    logo: logoReducer,
    newReports: newReportsReducer,
    reports: reportsReducer,
    invoices: invoicesReducer,
    carriers: carriersReducer,
    createInvoice: persistReducer(createInvoicePersistConfig, createInvoiceReducer)
});

export {rootPersistConfig, rootReducer};
